import { CommonFileModel } from "models/CommonFileModel";
import React, { SyntheticEvent } from "react";
import { MdCancel } from "react-icons/md";
import XButton2 from "../button/XButton2";
import { ContextModel } from "models";

type PROPS = {
  data?: CommonFileModel;
  accept?: string;
  preview?: boolean;
  previewWidth?: string;
  previewHeight?: string;
  onChange?: (data: CommonFileModel | undefined) => boolean | void;
  hide_file_name?: boolean;
  show_preview_file_name?: boolean;
  disabled?: boolean;

  ctx?: ContextModel;
  name?: string;
  maxSize?: number;
  withNew?: boolean;
};

const FileInput: React.FC<PROPS> = (props) => {
  const ref = React.useRef<HTMLInputElement>(null);

  const [fileName, setFileName] = React.useState("");
  const [data, setData] = React.useState("");
  const [link, setLink] = React.useState("");

  const accept = props.accept ?? "image/*";

  const onClick = () => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const previewImage = (e: SyntheticEvent) => {
    const fileReader = new FileReader();
    const target = e.target as HTMLInputElement;
    const files = target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (props.maxSize) {
        const max = props.maxSize * 1024 * 1024;
        const _ = `fileSize:${file.size}\n     max:${max}`;
        if (file.size > max) {
          console.log(`[File Size NG]\n${_}`);
          if (props.ctx) {
            props.ctx.msgDialog.setState({
              message: props.name
                ? `${props.name}は最大${props.maxSize}MBまで登録可能です。`
                : `${props.maxSize}MBまで登録可能です。`,
            });
          }
          clearPreview();
          return;
        } else {
          console.log(`[File Size OK]\n${_}`);
        }
      }

      fileReader.readAsDataURL(files[0]);
      fileReader.onload = (e) => {
        const target = e.target;
        if (target) {
          const file_name = files[0].name;
          const file_data = target.result as string;
          if (props.data) {
            props.data.file_name = file_name;
            props.data.file_data = file_data;
            if(props.withNew) {
              props.data.is_new = true;
            }
          }
          setFileName(file_name);
          setData(file_data);
        }
        if (props.onChange) {
          const result = props.onChange(props.data);
          if (result) {
            clearPreview();
          }
        }
      };
    }
  };

  const clearPreview = () => {
    if (props.data) {
      const data = props.data;
      data.file_name = "";
      data.image_url = "";
      delete data.file_data;
      delete data.image_data;
    }
    setFileName("");
    setData("");
    setLink("");
    if (ref.current) {
      ref.current.value = "";
    }
    if (props.onChange) {
      props.onChange(props.data);
    }
  };

  const previewWidth = props.previewWidth ?? "250px";
  const previewHeight = props.previewHeight ?? "250px";

  React.useEffect(() => {
    const data = props.data;
    if (data) {
      setFileName(data.file_name);
      if (data.file_data) {
        setData(data.file_data);
      } else if (data.image_data) {
        setData(data.image_data);
      } else {
        setData("");
      }
      setLink(data.image_url);
    } else {
      setFileName("");
      setData("");
      setLink("");
    }
  }, [props.data]);

  const src = data ? data : link ? link : "";

  return (
    <div className="flex flex-col">
      <input
        hidden
        type="file"
        accept={accept}
        onChange={previewImage}
        ref={ref}
      />
      <div className="flex items-center gap-4">
        <button
          className={`${props.disabled ? 'secondary-disabled px-4 py-2 ' : 'secondary px-4 py-2 '}`}
          onClick={onClick}
          disabled={props.disabled}
        >
          <span className="whitespace-nowrap">ファイル選択</span>
        </button>
        {props.hide_file_name ? (
          <></>
        ) : (
          <span className="overflow-hidden text-ellipsis">{fileName}</span>
        )}
        {!props.preview && (data || link) && (
          <XButton2
            action={() => {
              clearPreview();
            }}
          />
        )}
      </div>
      {props.preview &&
        (src ? (
          <div className="m-2 flex">
            <div
              className="relative border rounded-sm"
              style={{
                width: previewWidth,
                height: previewHeight,
              }}
            >
              <img
                src={src}
                alt=""
                style={{
                  width: previewWidth,
                  height: previewHeight,
                  objectFit: "contain",
                }}
              />
              {props.show_preview_file_name && (
                <div className="text-right text-sm text-gray-400 overflow-hidden text-ellipsis">
                  {fileName}
                </div>
              )}
              <div
                className="absolute top-0 right-0"
                style={{ transform: "translate(10px, -10px)" }}
              >
                <button onClick={clearPreview}>
                  <MdCancel className="text-3xl" />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <></>
        ))}
    </div>
  );
};

export default FileInput;
